function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.6 11.6L2.66997 11.596C2.94542 11.564 3.16397 11.3454 3.19596 11.07L3.2 11V3.2H11L11.07 3.19596C11.3684 3.1613 11.6 2.9077 11.6 2.6C11.6 2.2923 11.3684 2.0387 11.07 2.00404L11 2H2.6L2.53003 2.00404C2.25458 2.03603 2.03603 2.25458 2.00404 2.53003L2 2.6V11L2.00404 11.07C2.03603 11.3454 2.25458 11.564 2.53003 11.596L2.6 11.6ZM14.0664 14.6664L14.1364 14.6624C14.4118 14.6304 14.6304 14.4118 14.6624 14.1364L14.6664 14.0664V5.66641L14.6624 5.59643C14.633 5.34394 14.447 5.13926 14.204 5.08225L14.1364 5.07044L14.0664 5.06641H5.66641L5.59643 5.07044C5.32098 5.10244 5.10244 5.32098 5.07044 5.59643L5.06641 5.66641V14.0664L5.07044 14.1364C5.09977 14.3889 5.28586 14.5936 5.52883 14.6506L5.59643 14.6624L5.66641 14.6664H14.0664ZM6.26693 6.26693V13.4669H13.4669V6.26693H6.26693Z",
  fill: "#0067E2"
});

var SvgIcCopyBlue = function SvgIcCopyBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcCopyBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-copy-blue.5b56f528.svg";
export { ForwardRef as ReactComponent };